export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-thumbnail-960-5d27a72cb6946760ad8019757c6c2af9.png";